import React from 'react'
import '../assets/css/DataMonitor.css'
//plugin
import { appleStock } from '@vx/mock-data';
import { Group } from '@vx/group';
import { AreaClosed } from '@vx/shape';
import { scaleTime, scaleLinear } from '@vx/scale';
import { AxisLeft, AxisBottom } from '@vx/axis';
import { extent, max, min} from 'd3-array';
import { Text } from '@vx/text';
import Tooltip from '@material-ui/core/Tooltip';
//store
//store
import events from '../store/events';
import {observer} from 'mobx-react';

@observer
class DataMonitor extends React.Component {
  render () {
    const { width , height ,data } = this.props;
    return(
      <div className='DataMonitor'>
        <svg width={width} height={height}>
          <rect width={width} height={height} style={{fill:'#fff'}}/>
          <Text
            x={width/2}
            y={height/5}
            textAnchor='middle'
            verticalAnchor='middle'
            fontSize='1em'
          >
            {this.props.property}
          </Text>
          <Text
            width={width/3}
            x={width/2}
            y={height/2}
            textAnchor='middle'
            verticalAnchor='middle'
            scaleToFit
            style={this.props.error?{fill:'red'}:null}
          >
            {String(this.props.value)}
          </Text>
          {this.props.error?
          <Text
            width={width}
            x={width/2}
            y={height*2/3}
            textAnchor='middle'
            verticalAnchor='middle'
            style={this.props.error?{fill:'red'}:null}
            >
            Object type is not support currently.
          </Text>
          :null
          }
        </svg>
      </div>
    )
  }
}

export default DataMonitor;



// WEBPACK FOOTER //
// ./src/components/DataMonitor.js